__webpack_require__.p = "/soc-survey/frontend/";